export const dashboardConstants = {
    GET_ALL_DASHBOARD : 'GET_ALL_DASHBOARD',
    GET_ALL_DASHBOARD_PENDING : 'GET_ALL_DASHBOARD_PENDING',
    GET_ALL_DASHBOARD_FULFILLED : 'GET_ALL_DASHBOARD_FULFILLED',
    GET_ALL_DASHBOARD_FAILURE : 'GET_ALL_DASHBOARD_FAILURE',
    GET_ALL_DASHBOARD_REJECTED : 'GET_ALL_DASHBOARD_REJECTED',
};
